export type SalesRepPaymentRow = {
  payment_percentage?: number | null;
  total_invoices_amount?: number | string | null;
  total_paid_amount?: number | string | null;
  has_invoices_in_period?: boolean;
};

export function hasInvoicesInPeriod(row: SalesRepPaymentRow): boolean {
  return row.has_invoices_in_period !== false;
}

/**
 * Total payment % = (sum of paid amounts / sum of invoice amounts incl. VAT)
 * for customers with invoices in the selected period only.
 */
export function totalPaymentPercentage(rows: SalesRepPaymentRow[]): number {
  const eligible = rows.filter(hasInvoicesInPeriod);
  if (eligible.length === 0) {
    return 0;
  }

  const totalInvoices = eligible.reduce(
    (acc, row) => acc + (Number.parseFloat(String(row.total_invoices_amount ?? 0)) || 0),
    0
  );
  const totalPaid = eligible.reduce(
    (acc, row) => acc + (Number.parseFloat(String(row.total_paid_amount ?? 0)) || 0),
    0
  );

  if (totalInvoices <= 0) {
    return 0;
  }

  return (totalPaid / totalInvoices) * 100;
}

/** @deprecated Use totalPaymentPercentage */
export const averagePaymentPercentage = totalPaymentPercentage;
